import React, { useState } from 'react';
import { User, Briefcase, Building, Globe, ShieldAlert, ChevronDown, Check, Landmark } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function PersonaSwitcher() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [currentPersona, setCurrentPersona] = useState({
    name: 'Switch Persona',
    icon: User
  });
  const personas = [{
    name: 'Individual Buyer',
    role: 'buyer',
    icon: User,
    path: '/dashboard',
    desc: 'Standard residential search'
  }, {
    name: 'NRI Buyer',
    role: 'nri',
    icon: Globe,
    path: '/dashboard/nri-buyer',
    desc: 'Remote investment tools'
  }, {
    name: 'Individual Seller',
    role: 'seller',
    icon: User,
    path: '/dashboard/seller',
    desc: 'Single plot listing'
  }, {
    name: 'Developer',
    role: 'developer',
    icon: Building,
    path: '/dashboard/developer',
    desc: 'Bulk inventory & leads'
  }, {
    name: 'Govt Authority',
    role: 'authority',
    icon: Landmark,
    path: '/authority',
    desc: 'Auctions & compliance'
  }, {
    name: 'Admin',
    role: 'admin',
    icon: ShieldAlert,
    path: '/admin',
    desc: 'Verification & moderation'
  }];
  const handleSelect = (persona: any) => {
    setCurrentPersona(persona);
    setIsOpen(false);
    navigate(persona.path);
  };
  return <div data-testid="persona-switcher" className="relative" data-id="element-956">
      <button data-testid="persona-switcher-toggle-btn" onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-2 border border-gray-300 bg-gray-50 hover:bg-gray-100 text-sm font-medium rounded-sm min-w-[140px] md:min-w-[180px]" data-id="element-957">
        <currentPersona.icon className="w-4 h-4 text-gray-500" data-id="element-958" />
        <span data-testid="persona-switcher-current-label" className="flex-1 text-left truncate hidden sm:block" data-id="element-959">
          {currentPersona.name}
        </span>
        <ChevronDown className="w-4 h-4 text-gray-400" data-id="element-960" />
      </button>

      {isOpen && <div data-testid="persona-switcher-dropdown" className="absolute top-full right-0 mt-1 w-64 bg-white border border-gray-300 shadow-lg z-50 py-1 max-h-[80vh] overflow-y-auto" data-id="element-961">
          <div data-testid="persona-switcher-dropdown-header" className="px-3 py-2 border-b border-gray-100 text-xs font-mono text-gray-400 uppercase" data-id="element-962">
            Select View Mode
          </div>
          {personas.map(persona => <button key={persona.name} data-testid={`persona-switcher-${persona.role}-btn`} onClick={() => handleSelect(persona)} className="w-full text-left px-3 py-3 hover:bg-gray-50 flex items-start gap-3 border-b border-gray-50 last:border-0" data-id="element-963">
              <div className="mt-0.5 p-1 bg-gray-100 rounded-sm" data-id="element-964">
                <persona.icon className="w-4 h-4 text-gray-600" data-id="element-965" />
              </div>
              <div data-id="element-966">
                <div className="font-bold text-sm text-[#1f2933]" data-id="element-967">
                  {persona.name}
                </div>
                <div className="text-xs text-gray-500" data-id="element-968">{persona.desc}</div>
              </div>
              {currentPersona.name === persona.name && <Check className="w-4 h-4 text-green-600 ml-auto mt-0.5" data-id="element-969" />}
            </button>)}
        </div>}
    </div>;
}